import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import { Button } from 'reactstrap';
import { IoNotificationsOutline } from "react-icons/io5";

var stateManager = require('../../utils/state/stateManager.js');
var navigationPageAction = require('../../utils/state/actions/views/navigationPage/navigationPageAction');
var logger = require('../../utils/logger/logger');
var storefrontUtility = require('../../utils/domain/storefrontUtility');
var flipdishManualSaleAcceptanceTimeCalculator = require('../../utils/domain/sales/flipdishManualSaleAcceptanceTimeCalculator');
var formatter = require('../../utils/formatter/formatter.js');
var dateUtil = require('../../utils/dateUtil/dateUtil');
var saleCalculator = require('../../utils/domain/sales/saleCalculator');
var guidUtil = require('../../utils/guid/guidUtil');
var jobsServer = require('../../utils/jobs/jobsServer');
var rmsApiProxyRetry = require('../../utils/api/rmsApiProxyRetry');
var sounds = require('../../utils/sounds/sounds');
var viewUtil = require('../../utils/view/viewUtil');
var userNotificationsUtil = require('../../utils/userNotifications/userNotificationsUtil');
var staffUtility = require('../../utils/domain/staff/staffUtility');
var staffAccessUtility = require('../../utils/domain/staff/staffAccessUtility');
var staffActivities = require('../../utils/domain/staff/staffActivities');
var translator = require('../../utils/translator/translator.js');
var navigationButtonsIds = require('../../views/Navigation/navigationButtonsIds');

class UserNotificationAlertComponent extends Component 
{
    constructor(props)
    {
        super(props);
        this.acceptOrder = this.acceptOrder.bind(this);
        this.rejectOrder = this.rejectOrder.bind(this);
        this.orderDetails = this.orderDetails.bind(this);

        var sale = this.props.userNotification.payload;
        logger.info(`Displaying manual accept user notification for order number: ${sale.number}`)
    }

    componentDidMount() 
    {
        this.timerID = setInterval
        (
          () => 
          {
                var sale = this.props.userNotification.payload;
                logger.info(`Playing reminder sound of manual accept user notification for order number: ${sale.number}`)
                sounds.playNewOrderSound();
          },
          10000
        );
    }
    
    componentWillUnmount() 
    {
        clearInterval(this.timerID);
    }

    render()
    {
        var sale = this.props.userNotification.payload;
        var storefront = storefrontUtility.getStorefrontById(sale.storefrontId);
        
        var disabled = false;
        if (staffUtility.getLoginStaff() == null || !staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder))
            disabled = true;

        
        return <div className='d-flex flex-column' style={{paddingTop:'20px', paddingBottom:'20px'}}>
                    <div className='d-flex flex-row justify-content-center align-content-center'>
                        <IoNotificationsOutline size={40}/>
                        <div style={{marginLeft:'10px', fontSize:'2rem'}}>{translator.getLabel("new_order")}</div>
                    </div>
                    <div>
                        <hr/>
                    </div>
                    <div style={{textAlign:'center', fontSize:'1.5rem', marginRight:'10px'}}>
                        <table width="100%">
                            <tr>
                                <td style={{width:'99%', textAlign:'start'}}>
                                {translator.getLabel("order_number")}
                                </td>
                                <td style={{textAlign:'right', whiteSpace:'nowrap'}}>
                                    {sale.number}
                                </td>
                            </tr>

                            <tr>
                                <td style={{width:'99%', textAlign:'start'}}>
                                    {translator.getLabel("storefront")}
                                </td>
                                <td style={{textAlign:'right', whiteSpace:'nowrap'}}>
                                    {storefront.name}
                                </td>
                            </tr>

                            <tr>
                                <td style={{width:'99%', textAlign:'start'}}>
                                {translator.getLabel("dispatch")}
                                </td>
                                <td style={{textAlign:'right', whiteSpace:'nowrap'}}>
                                    {sale.dispatchType}
                                </td>
                            </tr>

                            <tr>
                                <td style={{width:'99%', textAlign:'start'}}>
                                {translator.getLabel("sale_price")}
                                </td>
                                <td style={{textAlign:'right', whiteSpace:'nowrap'}}>
                                    {formatter.convertToCurrencyFormat(saleCalculator.calculateTotalSalePrice(sale))}
                                </td>
                            </tr>

                            <tr>
                                <td style={{width:'99%', textAlign:'start'}}>
                                {translator.getLabel("expected_time")}
                                </td>
                                <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'end'}}>
                                    {flipdishManualSaleAcceptanceTimeCalculator.getFormattedDateTimeToLocalTime(flipdishManualSaleAcceptanceTimeCalculator.getExpectedHandoverTime(sale))}
                                </td>
                            </tr>

                            <tr>
                                <td style={{width:'99%', textAlign:'start'}}>
                                {translator.getLabel("payment_status")}
                                </td>
                                <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'end'}}>
                                    {saleCalculator.isSaleFullyPaid(sale) ? "Paid" : "NOT Paid"}
                                </td>
                            </tr>

                        </table>

                        <div>
                            <hr/>
                        </div>

                        <div>
                            {this.renderLoginWarning()}
                        </div>

                        <div>
                            <Button color="success" size="lg" block disabled={disabled} 
                                        onClick={this.acceptOrder}>
                                    {translator.getLabel("accept")}
                                </Button>
                        </div>

                        <div style={{marginTop:'5px'}}>
                            <Button color="danger" size="lg" block disabled={disabled}
                                        onClick={()=>{this.rejectOrder("StoreClosed")}}>
                                    {translator.getLabel("reject_store_closed")}
                                </Button>
                        </div>

                        <div style={{marginTop:'5px'}}>
                            <Button color="danger" size="lg" block disabled={disabled}
                                        onClick={()=>{this.rejectOrder("TooBusy")}}>
                                    {translator.getLabel("reject_too_busy")}
                                </Button>
                        </div>

                        <div style={{marginTop:'20px'}}>
                            <Button color="warning" size="lg" block disabled={disabled}
                                        onClick={this.orderDetails}>
                                    {translator.getLabel("details")}
                                </Button>
                        </div>
                    </div>

               </div>
    }

    renderLoginWarning()
    {
        if (staffUtility.getLoginStaff() == null)
        {
            return <div>
                        <div style={{color:'darkred', textAlign:'center', fontSize:'1.5rem'}}>
                                    {translator.getLabel("please_login_to_place_an_order")}
                        </div>
                        <hr style={{margin:'0px', padding:'0px', marginTop:'20px', marginBottom:'20px'}}/>
                    </div>
        }

        if (!staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder))
        {
            return <div>
                        <div style={{color:'darkred', textAlign:'center', fontSize:'1.2rem'}}>
                                    {translator.getLabel("not_sufficient_privileges_to_place_an_order")}
                        </div>
                        <hr style={{margin:'0px', padding:'0px', marginTop:'20px', marginBottom:'20px'}}/>
                    </div>
        }

        return null;
    }

    acceptOrder()
    {
        var notificationId = this.props.userNotification.id;
        var sale = this.props.userNotification.payload;

        const handOverDateTime = flipdishManualSaleAcceptanceTimeCalculator.getExpectedHandoverTime(sale);
        let estimatedTimeInMinutes = dateUtil.differenceInMinutes(handOverDateTime, dateUtil.getNow());
        if(estimatedTimeInMinutes < 0) estimatedTimeInMinutes = 0;
        estimatedTimeInMinutes = Math.ceil(estimatedTimeInMinutes);
        const notificationResponse = { type: "manual.accept.order", action: "accept", estimatedTime: estimatedTimeInMinutes };

        logger.info(`User accepted the order without changing time for order number: ${sale.number}. The estimated time in minutes is ${estimatedTimeInMinutes}`);
        jobsServer.addJob(guidUtil.generateGuid(), "Manual.Order.Accept", 
        async ()=>
        {
            return rmsApiProxyRetry.post(`${rmsApiProxyRetry.getOrgContextToUrl()}/userNotifications/${notificationId}`, notificationResponse);
        });

        viewUtil.clearAlertForId(notificationId);
        userNotificationsUtil.deleteAndPublishNotification(notificationId);
    }

    rejectOrder(rejectionReason)
    {
        var notificationId = this.props.userNotification.id;
        var sale = this.props.userNotification.payload;

        viewUtil.showPrompt(translator.getLabel("order_reject"), `${translator.getLabel("you_are_about_to_reject_order")} (${sale.number}).`, translator.getLabel("are_you_sure"),
        ()=>
        {
            const notificationResponse = { type: "manual.accept.order", action: "reject", reason: rejectionReason };

            logger.info(`User rejected the order for order number: ${sale.number}. with reason as ${rejectionReason}`);
            jobsServer.addJob(guidUtil.generateGuid(), "Manual.Order.Reject", 
            async ()=>
            {
                return rmsApiProxyRetry.post(`${rmsApiProxyRetry.getOrgContextToUrl()}/userNotifications/${notificationId}`, notificationResponse);
            });
    
            viewUtil.clearAlertForId(notificationId);
            userNotificationsUtil.deleteAndPublishNotification(notificationId);
        })
    }

    orderDetails()
    {
        var notificationId = this.props.userNotification.id;
        var sale = this.props.userNotification.payload;

        logger.info(`User presses the detail button order number: ${sale.number}`);

        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = navigationButtonsIds.notifications;
        navigationDialoguePayload.selectedNotificationId = notificationId;
     
        stateManager.getStore().dispatch(navigationPageAction.createAction(navigationDialoguePayload));
        viewUtil.clearAlertForId(notificationId);
    }
}

const mapStateToProps = state => 
{
    return { 
                staffLoginData: state.staffLoginData,
          }
}

export default connect(mapStateToProps)(UserNotificationAlertComponent)